import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { heroData } from '../../../data/hero.data';
import { WizardComponent } from '../wizard/wizard.component';

@Component({
  selector: 'app-hero',
  standalone: true,

  imports: [CommonModule, FormsModule, WizardComponent],
  templateUrl: './hero.component.html',
  styleUrl: './hero.component.css',
})
export class HeroComponent {
  @Input() googleApiKey: string | undefined;
  @Input() questionStart: boolean = false;
  @Output() questionStartChange = new EventEmitter<boolean>();

  infoCards = heroData.infoCards;
  activeFormNumber: number | null = null;

  checkFormNumber(number: number) {
    this.activeFormNumber = number;
  }
}
